import React from 'react';

import dayjs from 'dayjs';

import { defaultRenderers } from 'components/Grid';
import type { ColumnDefinition } from 'components/Grid/types';
import { StyledTaskDueDate } from 'containers/Tasks/components/TasksTable/styles';
import { RiskActionRow, RiskActionStatus } from 'utils/api/modules/risks';
import { ScheduleStatus, TaskStatus } from 'utils/api/modules/tasks/tasks.constants';

import RiskActionStatusChip from './RiskActionStatusChip';
import { StyledOneLine } from './styles';

type Cell = { row: RiskActionRow };

export const dueDateStatus = (row: RiskActionRow): TaskStatus | ScheduleStatus.Overdue => {
  if (row.status !== RiskActionStatus.ToDo) return TaskStatus.Completed;
  return row.dueDate && dayjs(row.dueDate).isBefore(dayjs()) ? ScheduleStatus.Overdue : TaskStatus.ToDo;
};

export const riskActionColumns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1.8,
    minWidth: 220,
    renderCell: ({ row }: Cell) => <StyledOneLine title={row.name}>{row.name}</StyledOneLine>,
  },
  {
    field: 'type',
    headerName: 'Type',
    flex: 1.2,
    minWidth: 190,
    sortable: false,
    nativeFilter: true,
    renderCell: ({ row }: Cell) => row.typeLabel,
  },
  {
    field: 'assignedTo',
    headerName: 'Assigned to',
    flex: 1.2,
    minWidth: 150,
    sortable: false,
    nativeFilter: true,
    renderCell: defaultRenderers.user,
    valueGetter: (_value: unknown, row: RiskActionRow) => ({ value: row.assignedTo }),
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1.1,
    minWidth: 190,
    sortable: false,
    nativeFilter: true,
    renderCell: ({ row }: Cell) => <RiskActionStatusChip status={row.status} />,
  },
  {
    field: 'dueDate',
    headerName: 'Due date',
    flex: 1,
    minWidth: 130,
    nativeFilter: true,
    renderCell: ({ row }: Cell) =>
      row.dueDate && <StyledTaskDueDate date={row.dueDate} status={dueDateStatus(row)} showTime />,
  },
] as unknown as ColumnDefinition[];
